export default __webpack_public_path__ + "static/media/onboarding.829d6e57.svg";